module.exports = __webpack_public_path__ + "img/bg-2.72353483.png";